export const PATIENTS_TABS = {
  searchAllPatients: 0,
  byIDN: 1,
  byDepartment: 2,
} as const;

const PATIENTS_TABS_LABEL: Record<
  (typeof PATIENTS_TABS)[keyof typeof PATIENTS_TABS],
  string
> = {
  [PATIENTS_TABS.searchAllPatients]: 'Search All Patients',
  [PATIENTS_TABS.byIDN]: 'By IDN',
  [PATIENTS_TABS.byDepartment]: 'By Department',
} as const;

type PatientsTabsKey = keyof typeof PATIENTS_TABS;
export type PatientsTabsValue =
  (typeof PATIENTS_TABS)[keyof typeof PATIENTS_TABS];

export const PatientsTabsConfig = (
  Object.keys(PATIENTS_TABS) as PatientsTabsKey[]
).map((key) => {
  const label = PATIENTS_TABS_LABEL[PATIENTS_TABS[key]];

  return {
    label,
    'aria-label': label,
  };
});

export const PatientSortValues = [
  'lastName',
  'alertsLast24hours',
  'createdAt',
  'dateOfBirth',
  'firstName',
  'phoneNumberLast4Digits',
  'status',
  'lactate',
] as const;
